module.exports = __webpack_public_path__ + "img/aktuelles_adventsfenster2021.76e7c55f.png";